import CodeBlock from '@/components/global/CodeBlock';

const CodeBlockWrapper = ({ blok }) => {
  const { code, language, copy_enabled } = blok;

  return (
    <>
      <CodeBlock code={code} language={language} copyEnabled={copy_enabled} />
    </>
  );
};

export default CodeBlockWrapper;
